const Colors = {
  ginger: 'rgba(170,89,75,1.0)',
  blush: 'rgba(232,225,218,1.0)',
  periwinkle: 'rgba(158,168,204,1.0)',
  quartz: 'rgba(218,181,157,1.0)',
  cloud: 'rgba(196,210,214,1.0)',
  olive: 'rgba(139,153,118,1.0)',
  meringue: 'rgba(244,250,184,1.0)',
  stone: 'rgba(245,244,243,1.0)',
  charcoal: 'rgba(57,58,54,1.0)',
  black: 'rgba(0,0,0,1.0)',
  white: 'rgba(255,255,255,1.0)',
  darkGray: 'rgba(51,51,51,1.0)',
  gray: 'rgba(153,153,153,1.0)',
  lightGray: 'rgba(199,210,214,1.0)',
  lighterGray: 'rgba(205,213,224,1.0)',
  lightestGray: 'rgba(246,247,252,1.0)',
};

export default Colors;
